import { render, staticRenderFns } from "./juegoMillonario.vue?vue&type=template&id=5567e6fe"
import script from "./juegoMillonario.vue?vue&type=script&lang=js"
export * from "./juegoMillonario.vue?vue&type=script&lang=js"
import style0 from "./juegoMillonario.vue?vue&type=style&index=0&id=5567e6fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports